export const Colors: string[] = [
"rgba(58, 163, 176, 1)",
"rgba(235, 185, 92, 1)",
"rgba(117, 132, 160, 1)",
"rgba(237, 119, 27, 1)",
"rgba(41, 113, 187, 1)",
"rgba(73, 171, 225, 1)"
];

export const Borders: string[] = [
  "rgba(58, 163, 176, 0.6)",
  "rgba(235, 185, 92, 0.6)",
  "rgba(117, 132, 160, 0.6)",
  "rgba(237, 119, 27, 0.6)",
  "rgba(41, 113, 187, 0.6)",
  "rgba(73, 171, 225, 0.6)"
];
